import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['users'], ({ users }, { isCurrentUser }) => users.audit || isCurrentUser, 'user');
